{
	"content": {
		"declarationDetailsSection": {
			"title": "Deklarationsdetaljer",
			"description": "För att skapa deklarationen behövs kundens namn, adress och land för deklarationsinnehavaren. Informationen kan inte ändras i efterhand.",
			"customerLabel": "Kundkonto"
		},
		"provideDeclarationsDetailsSection": {
			"title": "Ange deklarationsdetaljer",
			"alertDescription": "Informationen du anger kommer att registreras permanent på deklarationen och kan inte ändras i efterhand.",
			"projectLabel": "Projektreferens",
			"companyNameLabel": "Företagsnamn",
			"streetLabel": "Gata",
			"zipCodeLabel": "Postnummer",
			"cityLabel": "Ort",
			"countryLabel": "Land"
		}
	},
	"summary": {
		"title": "Sammanfattning",
		"declarationTypeTitle": "Deklarationstyp",
		"customerProjectTitle": "Kundprojekt",
		"internalProjectOrProductTitle": "Internt projekt / produkt",
		"projectReferenceTitle": "Projektreferens",
		"materialHeaderTitle": "Material",
		"quantityHeaderTitle": "Kvantitet ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Allokerbara koldioxidreduktioner ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Ej allokerbar koldioxidreduktion ({{unit}})"
	},
	"errorMessages": {
		"projectRequired": "Projektreferens krävs",
		"companyNameRequired": "Företagsnamn krävs",
		"streetRequired": "Gata krävs",
		"zipCodeRequired": "Postnummer krävs",
		"cityRequired": "Ort krävs",
		"countryRequired": "Land krävs",
		"customerRequired": "Kund krävs"
	},
	"reviewDeclarationDetailsModal": {
		"title": "Granska deklarationssammanfattning",
		"description": "Vänligen granska uppgifterna du har angett för eventuella fel.",
		"alertDescription": "Informationen du har angett kommer att registreras permanent på deklarationen och kan inte ändras i efterhand.",
		"typeSectionTitle": "1. Typ",
		"declarationTypeLabel": "Deklarationstyp",
		"customerProjectTitle": "Kundprojekt",
		"internalProjectOrProductTitle": "Internt projekt / produkt",
		"projectReferenceLabel": "Projektreferens",
		"materialSectionTitle": "2. Material",
		"materialHeaderTitle": "Material",
		"quantityHeaderTitle": "Kvantitet ({{unit}})",
		"totalCarbonReductionsLabel": "Totala koldioxidreduktioner ({{unit}})",
		"declarationSectionTitle": "3. Deklaration",
		"companyNameLabel": "Företagsnamn",
		"streetLabel": "Gata",
		"zipCodeLabel": "Postnummer",
		"cityLabel": "Ort",
		"countryLabel": "Land",
		"backTitle": "Tillbaka",
		"submitTitle": "Ja, allt stämmer"
	},
	"submitTitle": "Skapa deklaration",
	"backTitle": "Tillbaka"
}
